export default "__VITE_ASSET__DzlmGjnv__"